import { useState, useEffect } from 'react'
import { getMyPair } from '../supabase/api'

export function usePair(userId, role) {
  const [pair, setPair] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!userId || !role) {
      setLoading(false)
      return
    }
    fetchPair()
  }, [userId, role])

  const fetchPair = async () => {
    try {
      setLoading(true)
      const data = await getMyPair(userId, role)
      setPair(data)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return { pair, loading, error, refetch: fetchPair }
}